import { render, staticRenderFns } from "./message-video.vue?vue&type=template&id=38d27a88&scoped=true"
import script from "./message-video.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-video.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-video.vue?vue&type=style&index=0&id=38d27a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d27a88",
  null
  
)

export default component.exports